import React from 'react';
import Feature, { FeatureType } from './components/Feature';
import { Block } from './styledComponents';

const FeaturesList = ({
  desktopSmallView,
  features,
}: {
  desktopSmallView?: boolean;
  features: FeatureType[];
}) => {
  return (
    <Block desktopSmallView={desktopSmallView}>
      {features.map(({ label, value }) => (
        <Feature
          key={label}
          desktopSmallView={desktopSmallView}
          label={label}
          value={value}
        />
      ))}
    </Block>
  );
};

export default FeaturesList;
